import styled from "styled-components";

export const ArrowSvg = styled.svg<{ $direction: "up" | "down" }>`
    display: inline-block;
    vertical-align: middle;
    margin-top: -0.1em;
    transform: ${({ $direction }) => ($direction === "down" ? "rotate(180deg)" : "rotate(0deg)")};
`;
